module.exports = __webpack_public_path__ + "img/bg-contact.4db01826.png";